import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    TextField,
    Select,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import BasicDialog from "../../../components/base/BasicDialog/BasicDialog";

import { useState } from "react";

import { useBookingCancellationReasons } from "../../../services/bookingsService";
import { useOfferCancellationReasons } from "../../../services/offersService";
import { useAgreementCancellationReasons } from "../../../services/agreementsService";

import { useEditReasonMutation } from "../../../services/leadsService";

import { getLocalizedProperty } from "../../../utils";

import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../base/SnackbarAlert/SnackbarSuccess";
import { SnackbarError } from "../../base/SnackbarAlert/SnackbarError";

export default function FiaskoEditDialog({ open, onClose, reasonId, agreementId, offerId, bookingId, reasonNote }) {
    const { t } = useTranslation();

    const [selectedReasonId, setSelectedReasonId] = useState(reasonId);
    const [selectedResonNote, setSelectedReasonNote] = useState(reasonNote);

    const { data: cancellationAgreementReasons, isLoading: isLoadingAgreementReasons } =
        useAgreementCancellationReasons({
            enabled: open && agreementId !== undefined,
    });

    const { data: cancellationOfferReasons, isLoading: isLoadingOfferReasons } = useOfferCancellationReasons({
        select: (data) => data.results,
        enabled: open && offerId !== undefined,
    });

    const { data: cancellationBookingReasons, isLoading: isLoadingBookingReasons } =
        useBookingCancellationReasons({
            select: (data) => data.results,
            enabled: open && bookingId !== undefined,
    });

    const { mutate: editReason, isPending: isEditReason } = useEditReasonMutation({
        onSuccess: () => {
            onClose();
            toast.custom(
                () => (
                    <SnackbarSuccess message={t("successfullyEdited")} />
                ),
                {
                    position: "bottom-right",
                },
            );
        },
        onError: (error) => {
            toast.custom(
                () => <SnackbarError message={t("errorOccured")} />,
                {
                    position: "bottom-right",
                },
            );
        },
    });
    
    return (
        <BasicDialog
            open={open}
            onClose={onClose}
            title={t("agreements.cancellationDialog.edit")}
            maxWidth="sm"
            showBottomCloseButton={false}
            showDialogActions={false}
        >
            <Box sx={{ p: 2 }}>
                <FormControl fullWidth>
                    <FormControl fullWidth disabled={isLoadingAgreementReasons || isLoadingOfferReasons || isLoadingBookingReasons}>
                        <InputLabel id="agreement-cancellation-reason-label">
                            {t("agreements.cancellationDialog.reasonLabel")}
                        </InputLabel>
                        <Select
                            labelId="agreement-cancellation-reason-label"
                            value={selectedReasonId}
                            label={t("agreements.cancellationDialog.reasonLabel")}
                            onChange={(e)=>setSelectedReasonId(e.target.value)}
                        >
                        {agreementId !== undefined && cancellationAgreementReasons?.map((reason) => (
                            <MenuItem key={reason.id} value={reason.id}>
                                {getLocalizedProperty(reason, "reason_name")}
                            </MenuItem>
                        ))}
                        {offerId !== undefined && cancellationOfferReasons?.map((reason) => (
                            <MenuItem key={reason.id} value={reason.id}>
                                {getLocalizedProperty(reason, "reason_name")}
                            </MenuItem>
                        ))}
                        {bookingId !== undefined && cancellationBookingReasons?.map((reason) => (
                            <MenuItem key={reason.id} value={reason.id}>
                                {getLocalizedProperty(reason, "reason_name")}
                            </MenuItem>
                        ))}
                        </Select>
                        <TextField
                            sx={{marginTop: 2}}
                            labelId="agreement-fiasco-reason-note_label"
                            value={selectedResonNote}
                            multiline
                            rows={2}
                            label={t("agreements.cancellationDialog.reasonNoteLabel")}
                            onChange={(e)=>setSelectedReasonNote(e.target.value)}
                        />
                    </FormControl>
                </FormControl>
                <LoadingButton
                    variant="contained"
                    color="success"
                    sx={{marginTop: 2}}
                    onClick={()=>editReason({agreement_id: agreementId, booking_id: bookingId, offer_id: offerId, reason: selectedReasonId, reason_note: selectedResonNote})}
                    disabled={isLoadingAgreementReasons || isLoadingOfferReasons || isLoadingBookingReasons || isEditReason}
                    loading={isLoadingAgreementReasons || isLoadingOfferReasons || isLoadingBookingReasons || isEditReason}
                    fullWidth
                >
                    {t("edit")}
                </LoadingButton>
            </Box>
        </BasicDialog>
    );
}
